import React from 'react'
import Navbar from '../common/navbar'
import Footer from '../common/footer'
import { Paper } from '@mui/material'
import { Link } from 'react-router-dom';
import FormDialog from '../modal/modal';
import AddStudenetForm from '../../AdminPages/form/addStudentForm';
import api from '../../API/api';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import { useNavigate, useLocation } from 'react-router-dom';

const StudentLogin = () => {

    const { state } = useLocation();

    // console.log("==>", state?.from);


    const navigate = useNavigate();
    const [modalData, setModalData] = React.useState();
    const [open, setOpen] = React.useState(false);
    const [login, setLogin] = React.useState({
        registration: '',
        dob: ''
    });

    const handleInput = (e) => {
        setLogin({
            ...login,
            [e.target.name]: e.target.value
        })
    }

    const handleClickOpen = (data) => {
        setOpen(true);
        // console.log(data, 'data for student add');
        setModalData(data)
    };

    const handleClose = () => { setOpen(false); }




    const checkStudent = () => {
        api.checkStudent(login).then((res) => {
            // console.log("res", res);

            if (res.data.status === 200) {
                // console.log("Success");
                // redirection  
                if (state?.from === 'blog') {
                    // console.log("blogg", res.data.student);
                    navigate('/StudentBlog', { state: res.data.student })
                } else {
                    navigate('/StudentDash', { state: res.data.student })
                }
            }

            if (res.data.status === 400) {
                toast.error(res.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
        })
            .catch((err) => {
                // console.log(err);
            })
    }



    return (
        <>
            <ToastContainer />
            <Navbar />
            <div className='my-0'>
                <Paper elevation={3}>

                    <div className=' p-5'>
                        <div className="text-center">
                            <h2> Login </h2>
                        </div>

                        <div className='row justify-content-center border my-3 py-3'>
                            <div className="col-12 col-md-6">
                                <div className="col-12">
                                    <label htmlFor="">Registration No</label>
                                    <input type="text" className='form-control' name="registration" id="" value={login.registration} onChange={handleInput} />
                                </div>
                                <div className="col-12">
                                    <label htmlFor="">Date of Birth</label>
                                    <input type="date" className='form-control' name="dob" id="" value={login.dob} onChange={handleInput} />
                                </div>
                                <div>
                                    <Link
                                        to="/RegisterStudent"
                                        state={{ from: 'public' }}
                                    //  onClick={handleClickOpen}
                                    > Not Register Yet? Click Here </Link>
                                </div>
                                <div className="col-md-12 text-center m-2 p-2">
                                    <button className='btn m-auto w-50 btn-success' onClick={checkStudent}>Login</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </Paper >
            </div >


            <FormDialog
                form={<AddStudenetForm from={'public'} handleClose={handleClose} handleClickOpen={handleClickOpen} modalData={modalData} />}
                title='Add Student' open={open} handleClickOpen={handleClickOpen} handleClose={handleClose}
            />


            <Footer />
        </>
    )
}

export default StudentLogin;